;(function($){

  $(window).ready(init);

  function init() {
    var MAP = '.PackMap';
    var TRIGGER_OPEN = '.PackInformations-mapTrigger';
    var TRIGGER_CLOSE = '.PackMap-close';

    function giveMapSize(){
      var width = $(window).width();
      var height = $(window).height();

      if (width > 992) {
        $(MAP).width(width - 160);
        $(MAP).height(height - 80);
      } else {
        $(MAP).width(width);
        $(MAP).height(height);
      }

    }

    giveMapSize();

    $(window).on('resize', function(){
      giveMapSize();
    });

    $(TRIGGER_OPEN).on('click', function(){
      $(MAP).addClass('mapShow');
    });

    $(TRIGGER_CLOSE).on('click', function(){
      $(MAP).removeClass('mapShow');
    });
  }

})(jQuery);
